import { default as card } from "./card";
import CardBody from "./cardBody";
import CardFooter from "./cardFooter";
import CardHeader from "./cardHeader";
import CardSubTitle from "./cardSubTitle";
import CardTitle from "./cardTitle";

import { default as collapsibleCard } from "./collapsible/card";
import CollapsibleCardHeader from "./collapsible/cardHeader";
import CollapsibleCardBody from "./collapsible/cardBody";

export type { CardProps } from "./card";
export type { CardBodyProps } from "./cardBody";
export type { CardFooterProps } from "./cardFooter";
export type { CardHeaderProps } from "./cardHeader";
export type { CardSubTitleProps } from "./cardSubTitle";
export type { CardTitleProps } from "./cardTitle";

const Card = Object.assign(card, {
  Header: CardHeader,
  Title: CardTitle,
  Body: CardBody,
  Footer: CardFooter,
  SubTitle: CardSubTitle,
});

export const CollapsibleCard = Object.assign(collapsibleCard, {
  Header: CollapsibleCardHeader,
  Title: CardTitle,
  Body: CollapsibleCardBody,
  Footer: CardFooter,
  SubTitle: CardSubTitle,
});

export default Card;
